import { useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@cold-ambulance/shadcn';
import {
  ReviewRequestDetails,
  ReviewRequestDetailsSkeleton,
  useData,
} from '@cold-ambulance/ui';

export function ViewRequestDialog({
  requestId,
  trigger,
}: {
  requestId: string;
  trigger: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);

  const requestQuery = useData(
    'GET /requests/{id}',
    { id: requestId },
    { enabled: open },
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Request Details</DialogTitle>
        </DialogHeader>
        {requestQuery.isLoading ? (
          <ReviewRequestDetailsSkeleton />
        ) : requestQuery.data ? (
          <ReviewRequestDetails request={requestQuery.data} />
        ) : (
          <div className="text-destructive py-6 text-center text-sm">
            Unable to load request details.
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
